import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  Link,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Menu,
  MenuItem,
} from "@mui/material";
import { styled } from "@mui/system";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import useMediaQuery from "@mui/material/useMediaQuery";
import Cookies from "js-cookie";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import BASE_URL from "../config/apiConfig";

const CustomButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#51833a",
  color: "white",
  textTransform: "capitalize",
  "&:hover": {
    backgroundColor: "#0056b3",
  },
}));

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(max-width:960px)");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get("user_auth_token");
    setIsLoggedIn(!!token);
  }, []);

  const toggleDrawer = (open) => {
    setDrawerOpen(open);
  };

  const isActive = (path) => location.pathname === path;

  const handleButtonClick = () => {
    navigate(isLoggedIn ? "/user/home" : "/user/login");
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadPDF = () => {
    const pdfUrl = `${BASE_URL}/static/SampleReport/personalised_farm_advisory_report.pdf`;
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "Demo_Report.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    handleMenuClose();
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "#fff",
        color: "#3e403b",
        padding: "10px 20px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
        <RouterLink to="/" style={{ textDecoration: "none" }}>
          <Box
            component="img"
            src="/LOGOS/Farmology-Logo-e1687720251448.png"
            alt="Logo"
            sx={{ height: isMobile ? "40px" : "50px", marginRight: "20px" }}
          />
        </RouterLink>

        <Box
          sx={{
            display: "flex",
            gap: isTablet ? "7px" : "30px",
            alignItems: "center",
            marginLeft: "auto",
          }}
        >
          {isMobile ? (
            <>
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={() => toggleDrawer(true)}
              >
                <MenuIcon />
              </IconButton>
              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={() => toggleDrawer(false)}
              >
                <List>
                  {["/", "/about", "/service", "/pricing", "/contact"].map(
                    (path, index) => (
                      <ListItem
                        button
                        component={RouterLink}
                        to={path}
                        onClick={() => toggleDrawer(false)}
                        key={index}
                      >
                        <ListItemText
                          primary={
                            path === "/"
                              ? "Home"
                              : path.slice(1).charAt(0).toUpperCase() +
                                path.slice(2)
                          }
                        />
                      </ListItem>
                    )
                  )}
                  <ListItem
                    button
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  >
                    <ListItemText primary="Demo" />
                    {mobileMenuOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={mobileMenuOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItem button onClick={handleDownloadPDF}>
                        <ListItemText primary="Download Report" />
                      </ListItem>
                    </List>
                  </Collapse>
                  <ListItem
                    button
                    onClick={() => {
                      toggleDrawer(false);
                      handleButtonClick();
                    }}
                  >
                    <CustomButton variant="contained" fullWidth>
                      {isLoggedIn ? "Dashboard" : "Get Started"}
                    </CustomButton>
                  </ListItem>
                </List>
              </Drawer>
            </>
          ) : (
            <>
              {["/", "/about", "/service", "/pricing", "/contact"].map(
                (path, index) => (
                  <Link
                    component={RouterLink}
                    to={path}
                    color="inherit"
                    underline="none"
                    key={index}
                    sx={{
                      fontWeight: isActive(path) ? "bold" : "normal",
                      color: isActive(path) ? "#51833a" : "inherit",
                    }}
                  >
                    <Typography>
                      {path === "/"
                        ? "Home"
                        : path.slice(1).charAt(0).toUpperCase() + path.slice(2)}
                    </Typography>
                  </Link>
                )
              )}
              <Button
                color="inherit"
                onClick={handleMenuClick}
                endIcon={<ArrowDropDownIcon />}
                sx={{ textTransform: "none" }} 
              >
                Demo
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem onClick={handleDownloadPDF}>Download Report</MenuItem>
              </Menu>
              <CustomButton
                variant="contained"
                onClick={handleButtonClick}
                sx={{ marginLeft: "20px" }}
              >
                {isLoggedIn ? "Dashboard" : "Get Started"}
              </CustomButton>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
